/** Payment methods — maps to PRD FR-2.4 */
export const PaymentMethod = {
  CARD: 'card',
  BANK_TRANSFER: 'bank_transfer',
  USSD: 'ussd',
  MOBILE_WALLET: 'mobile_wallet',
  CASH: 'cash',
  CASH_ON_DELIVERY: 'cash_on_delivery',
  CORPORATE_CREDIT: 'corporate_credit', // NET-30/60
} as const;

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod];

export const PaymentStatus = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  REFUNDED: 'refunded',
  PARTIALLY_REFUNDED: 'partially_refunded',
} as const;

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus];

export const PaymentGateway = {
  ALATPAY: 'alatpay',           // the only online gateway in use
  FLUTTERWAVE: 'flutterwave',   // wired, no credentials set
  SQUAD: 'squad',               // wired, no credentials set
  BANK_TRANSFER: 'bank_transfer', // teller marks paid manually — no gateway call
  CASH: 'cash',
} as const;

export type PaymentGateway = (typeof PaymentGateway)[keyof typeof PaymentGateway];

export interface Payment {
  id: string;
  orderId: string;
  customerId: string;
  amount: number;
  amountKobo: number; // Kobo precision for API calls
  method: PaymentMethod;
  gateway?: PaymentGateway;
  gatewayReference?: string;
  status: PaymentStatus;
  paidAt?: string;
  createdAt: string;
}

/** Finora Business sync tracking — maps to PRD Section 11.9 */
export const FinoraSyncStatus = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
  DEAD_LETTER: 'dead_letter',
  DRY_RUN: 'dry_run', // built + logged but not transmitted (sync disabled)
} as const;

export type FinoraSyncStatus = (typeof FinoraSyncStatus)[keyof typeof FinoraSyncStatus];

export interface FinoraReceiptSync {
  id: string;
  orderId: string;
  paymentId: string;
  finoraReceiptId?: string;
  finoraReceiptNumber?: string;
  finoraGlEntryId?: string;
  status: FinoraSyncStatus;
  attempts: number;
  lastAttemptAt?: string;
  lastError?: string;
  createdAt: string;
  completedAt?: string;
}
